import * as React from 'react';
export function mergeRefs(refs) {
    return (value)=>{
        for(let i = 0; i < refs.length; i++){
            const ref = refs[i];
            if (ref) {
                if (typeof ref === 'function') {
                    ref(value);
                } else {
                    ref.current = value;
                }
            }
        }
    };
}
export function useRefs(refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return React.useCallback(mergeRefs(refs), refs);
}

//# sourceMappingURL=useRefs.js.map